import ReactDOM from 'react-dom';
import { observer } from 'mobx-react-lite';

import { ToastItem } from './toast-item';
import { toastPool } from '../models/toast-pool';

import styles from './toasts-container.module.scss';
export const ToastContainer = observer(() => {
  if (toastPool.elements.length === 0) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={styles['container']} onClick={(e) => e.stopPropagation()}>
      {toastPool.elements.map((toast, index) => (
        <ToastItem key={toast.message + index} toast={toast} />
      ))}
    </div>,
    document.getElementById('toast-root') as HTMLElement,
  );
});
